<app-sales-credit-number [creditNumber]="data().number" [data]="data()" *ngIf="categoryCode !== 'kredicash' "></app-sales-credit-number>

<div class="container section__creditResume h-full">
  <div class="wrapper">
    <div class="sectionContainer fadeinright animation-duration-200">
      <article class="pb-40">
        <app-sales-breadcrumbs [routes]="routesBreadcrumb"></app-sales-breadcrumbs>

        <div class="mainInfo mb-30">
          <i class="mainIcon mainIcon--success">
            <app-success-lines-icon></app-success-lines-icon>
          </i>
          <h1>¡El proceso ha finalizado!</h1>
          <p>{{ 'A continuación un resumen del crédito:' | termReplace }}</p>
        </div>

        <div class="clientBox pb-25">
          <div class="icon">
            <app-client-icon></app-client-icon>
          </div>
          <div class="info">
            <p><strong>Cliente:</strong> {{ data().person?.first_name.toLowerCase() }} {{ data().person?.last_name.toLowerCase() }}</p>
            <p><strong>Documento:</strong> {{ data().person?.document_id_number }}</p>
          </div>
        </div>

        <div class="resumeBox">
          <div class="product mb-20">
            <div class="subtitle mb-10">
              <h2>Producto seleccionado</h2>
            </div>

            <div class="product__item">
              <div class="productListItem__cont">
                <div class="img">
                  <img src="assets/images/icon-telefono.svg" [alt]="data().product?.name">
                </div>
                <div class="info">
                  <div class="title">
                    <h3>
                      {{data().product?.name}}
                    </h3>
                  </div>
                  <div class="main-price" *ngIf=!macroFlowService.isExperanzaFlow(this.flowCode)>
                    <p>{{ getMainProductAmount() | currency}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="additionalProductSummary mb-15" *ngIf="hasAdditionalProduct()">
            <div class="separator">
              <i>
                <app-circle-full-plus-icon></app-circle-full-plus-icon>
              </i>
            </div>

            <div class="subtitle mb-10">
              <h2>Producto adicional</h2>
            </div>

            <div class="additionalProductSummary__item mb-15">
              <div class="additionalProductSummary__itemCont">
                <div class="category">
                  <span>{{ getAdditionalProduct()?.category }}</span>
                </div>

                <div class="info">
                  <h3>{{ getAdditionalProduct()?.name }}</h3>
                  <span>{{ getAdditionalProductNetAmount() | currency}}</span>
                </div>

                <div class="details">
                  <p><span>Monto: <strong>{{ getAdditionalProduct()?.amount | currency}}</strong></span> <span class="circle"></span> <span>Descuento: <strong>{{ getAdditionalProduct()?.discount_pct }}%</strong></span></p>
                </div>
              </div>
            </div>

            <div class="additionalProductSummary__breakdown">
              <div class="title">
                <i>
                  <app-money-white-icon></app-money-white-icon>
                </i>
                <h3>Detalle del crédito</h3>
              </div>

              <div class="summary">
                <ul>
                  <li>
                    <span class="text">Subtotal productos</span>
                    <span class="value">{{ getProductsSubtotal() | currency}}</span>
                  </li>
                  <li>
                    <span class="text">Abono</span>
                    <span class="value">- {{ getInstallmentAmount() | currency}}</span>
                  </li>
                  <li class="highlight">
                    <span class="text">Monto financiado total</span>
                    <span class="value">{{ getFinancedTotalAmount() | currency}}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="credit mb-20">
            <p *ngIf=!macroFlowService.isExperanzaFlow(this.flowCode)>Abono de <strong>{{ data().quotes?.installment.selected | currency}}</strong> y pago de <strong>{{ data().quotes?.quota.selected |  currency }} {{frequencyText()}}</strong> durante <strong>{{ data().quotes?.quota.quantity }} cuotas</strong>.</p>

            <p *ngIf=macroFlowService.isExperanzaFlow(this.flowCode)>Pagarás <strong>{{ data().quotes?.quota.selected | currency}}</strong> mensuales durante <strong>{{ data().quotes?.quota.quantity }} cuotas</strong> descontado de tu boleta de pago de la ONP.</p>
          </div>

          <div class="importantMsg mb-20" *ngIf="isFlowAddressSales">
            <i>
              <svg xmlns="http://www.w3.org/2000/svg" width="71" height="70" viewBox="0 0 71 70" fill="none">
                <path d="M35.5 70C28.5777 70 21.8108 67.9473 16.0551 64.1014C10.2993 60.2556 5.8133 54.7893 3.16423 48.3939C0.515165 41.9985 -0.177952 34.9612 1.17253 28.1719C2.52301 21.3825 5.85644 15.1461 10.7513 10.2513C15.6461 5.35644 21.8825 2.02301 28.6719 0.672531C35.4612 -0.677952 42.4985 0.0151648 48.8939 2.66423C55.2893 5.3133 60.7556 9.79934 64.6014 15.5551C68.4473 21.3108 70.5 28.0777 70.5 35C70.5 44.2826 66.8125 53.185 60.2487 59.7487C53.685 66.3125 44.7826 70 35.5 70ZM35.5 5.83335C29.7314 5.83335 24.0923 7.54394 19.2959 10.7488C14.4994 13.9537 10.7611 18.5089 8.55353 23.8384C6.34597 29.1679 5.76837 35.0324 6.89378 40.6901C8.01918 46.3479 10.797 51.5449 14.8761 55.624C18.9551 59.703 24.1521 62.4808 29.8099 63.6062C35.4677 64.7316 41.3321 64.154 46.6616 61.9465C51.9911 59.7389 56.5463 56.0006 59.7512 51.2041C62.9561 46.4077 64.6667 40.7686 64.6667 35C64.6667 27.2645 61.5938 19.8459 56.124 14.3761C50.6541 8.90626 43.2355 5.83335 35.5 5.83335Z" fill="#0046AD"/>
                <path d="M35.5 38.8889C34.7296 38.8788 33.9936 38.5683 33.4488 38.0235C32.9039 37.4787 32.5934 36.7426 32.5833 35.9722V22.3611C32.5833 21.5876 32.8906 20.8457 33.4376 20.2987C33.9846 19.7517 34.7265 19.4445 35.5 19.4445C36.2736 19.4445 37.0154 19.7517 37.5624 20.2987C38.1094 20.8457 38.4167 21.5876 38.4167 22.3611V35.9722C38.4066 36.7426 38.0961 37.4787 37.5513 38.0235C37.0065 38.5683 36.2704 38.8788 35.5 38.8889Z" fill="#0046AD"/>
                <path d="M35.5 50.5556C34.7296 50.5455 33.9936 50.235 33.4488 49.6901C32.9039 49.1453 32.5934 48.4093 32.5833 47.6389V45.6945C32.5833 44.9209 32.8906 44.179 33.4376 43.6321C33.9846 43.0851 34.7265 42.7778 35.5 42.7778C36.2736 42.7778 37.0154 43.0851 37.5624 43.6321C38.1094 44.179 38.4167 44.9209 38.4167 45.6945V47.6389C38.4066 48.4093 38.0961 49.1453 37.5513 49.6901C37.0065 50.235 36.2704 50.5455 35.5 50.5556Z" fill="#0046AD"/>
              </svg>
            </i>
            <p>Ahora puedes enviar el producto al cliente.</p>
          </div>

          <div class="noteMsg" *ngIf="showUnlockSimButton()">
            <p><strong>NOTA:</strong> Si el teléfono se encuentra bloqueado por cambio de SIM, por favor presiona:</p>
            <button pButton pRipple label="Desbloquear SIM Card" class="p-button-secondary p-button-raised p-button-rounded w-ful n-background n-shadow" [loading]="isLoading()" (click)="unlockSimCard()"></button>
          </div>

          <p *ngIf="statusText()">{{ statusText() }}</p>
        </div>
      </article>

      <footer>
        <div class="footer__content">
          <button pButton pRipple label="Volver al inicio" class="p-button-primary p-button-raised p-button-rounded w-full" (click)="onHomePage()" [disabled]="isLoading()"></button>
        </div>
      </footer>
    </div>
  </div>
</div>




<p-dialog [(visible)]="visibleSuccessSIM" [modal]="true" [draggable]="false" [resizable]="false" [closable]="true" position="bottom">
  <div class="dialog">
    <div class="container">
      <div class="wrapper">
        <div class="dialog__icon">
          <span>
            <svg width="71" height="70" viewBox="0 0 71 70" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M61.6795 9.4412L32.1677 38.9788L21.5219 28.3237C21.5219 28.3237 19.2311 26.5703 17.0749 28.7283C14.9188 30.8863 16.6707 33.1792 16.6707 33.1792L32.1677 48.6898L66.5307 14.2967C66.5307 14.2967 68.1478 12.0038 65.9917 9.9807C63.7008 7.95758 61.6795 9.4412 61.6795 9.4412Z" fill="#0046AD"/>
              <path d="M69.4955 32.2351C68.8217 31.5607 67.7437 31.1561 66.5308 31.1561C63.2967 31.1561 62.3534 33.5838 62.3534 34.9326C62.3534 42.0809 59.5235 48.8247 54.5375 53.815C49.5515 58.8054 42.6789 61.6378 35.6715 61.6378C28.5294 61.6378 21.7916 58.8054 16.8056 53.815C11.8196 48.8247 8.98968 41.946 8.98968 34.9326C8.98968 27.7842 11.8196 21.0405 16.8056 16.0501C21.7916 11.0597 28.6642 8.22736 35.6715 8.22736C38.0971 8.22736 40.6575 8.63199 43.0832 9.30636C45.6435 9.98073 47.5301 10.3854 49.1472 9.17148C50.2253 8.36223 50.8991 6.60886 50.7643 5.12524C50.6295 4.04624 50.0905 3.10212 49.1472 2.6975C47.3954 1.48362 40.2533 0 35.8063 0C31.0898 0 26.6428 0.944123 22.4654 2.6975C18.2879 4.45087 14.38 7.01349 11.1458 10.2505C4.13844 16.7245 0.5 25.6262 0.5 34.9326C0.5 44.3738 4.13843 53.1407 10.7415 59.7495C13.9757 62.9865 17.8836 65.5491 22.0611 67.3025C26.2386 69.0559 30.8203 70 35.402 70C44.835 70 53.5942 66.3584 60.1973 59.7495C66.8004 53.1407 70.4388 44.3738 70.4388 34.9326C70.5735 34.9326 70.5735 33.3141 69.4955 32.2351Z" fill="#0046AD"/>
            </svg>
          </span>
        </div>
        <div class="dialog__info">
          <h2>Éxito</h2>
          <p>Se ha desbloqueado exitosamente la SIM Card de tu teléfono.</p>
        </div>
        <div class="dialog__btn">
          <button pButton pRipple label="Volver" icon="pi pi-angle-left" iconPos="left" class="p-button-primary p-button-raised p-button-rounded w-full" (click)="visibleSuccessSIM = false"></button>
        </div>
      </div>
    </div>
  </div>
</p-dialog>

<!-- MODAL MENSAJE PARA ENVIO DE PRODUCTO -->
<p-dialog [(visible)]="visibleImportantMsg" [modal]="true" [draggable]="false" [resizable]="false" [closable]="true" position="bottom">
  <div class="dialog">
    <div class="container">
      <div class="wrapper">
        <div class="dialog__icon">
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="71" height="70" viewBox="0 0 71 70" fill="none">
              <path d="M35.5 70C28.5777 70 21.8108 67.9473 16.0551 64.1014C10.2993 60.2556 5.8133 54.7893 3.16423 48.3939C0.515165 41.9985 -0.177952 34.9612 1.17253 28.1719C2.52301 21.3825 5.85644 15.1461 10.7513 10.2513C15.6461 5.35644 21.8825 2.02301 28.6719 0.672531C35.4612 -0.677952 42.4985 0.0151648 48.8939 2.66423C55.2893 5.3133 60.7556 9.79934 64.6014 15.5551C68.4473 21.3108 70.5 28.0777 70.5 35C70.5 44.2826 66.8125 53.185 60.2487 59.7487C53.685 66.3125 44.7826 70 35.5 70ZM35.5 5.83335C29.7314 5.83335 24.0923 7.54394 19.2959 10.7488C14.4994 13.9537 10.7611 18.5089 8.55353 23.8384C6.34597 29.1679 5.76837 35.0324 6.89378 40.6901C8.01918 46.3479 10.797 51.5449 14.8761 55.624C18.9551 59.703 24.1521 62.4808 29.8099 63.6062C35.4677 64.7316 41.3321 64.154 46.6616 61.9465C51.9911 59.7389 56.5463 56.0006 59.7512 51.2041C62.9561 46.4077 64.6667 40.7686 64.6667 35C64.6667 27.2645 61.5938 19.8459 56.124 14.3761C50.6541 8.90626 43.2355 5.83335 35.5 5.83335Z" fill="#0046AD"/>
              <path d="M35.5 38.8889C34.7296 38.8788 33.9936 38.5683 33.4488 38.0235C32.9039 37.4787 32.5934 36.7426 32.5833 35.9722V22.3611C32.5833 21.5876 32.8906 20.8457 33.4376 20.2987C33.9846 19.7517 34.7265 19.4445 35.5 19.4445C36.2736 19.4445 37.0154 19.7517 37.5624 20.2987C38.1094 20.8457 38.4167 21.5876 38.4167 22.3611V35.9722C38.4066 36.7426 38.0961 37.4787 37.5513 38.0235C37.0065 38.5683 36.2704 38.8788 35.5 38.8889Z" fill="#0046AD"/>
              <path d="M35.5 50.5556C34.7296 50.5455 33.9936 50.235 33.4488 49.6901C32.9039 49.1453 32.5934 48.4093 32.5833 47.6389V45.6945C32.5833 44.9209 32.8906 44.179 33.4376 43.6321C33.9846 43.0851 34.7265 42.7778 35.5 42.7778C36.2736 42.7778 37.0154 43.0851 37.5624 43.6321C38.1094 44.179 38.4167 44.9209 38.4167 45.6945V47.6389C38.4066 48.4093 38.0961 49.1453 37.5513 49.6901C37.0065 50.235 36.2704 50.5455 35.5 50.5556Z" fill="#0046AD"/>
            </svg>
          </span>
        </div>
        <div class="dialog__info">
          <h2>Importante</h2>
          <p>Ahora puedes enviar el producto al cliente.</p>
        </div>
        <div class="dialog__btn">
          <button pButton pRipple label="Continuar" icon="pi pi-angle-right" iconPos="right" class="p-button-primary p-button-raised p-button-rounded w-full" (click)="visibleImportantMsg = false"></button>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
